<mat-toolbar class="header">
  <span class="title">Logs</span>
  <span class="example-spacer"></span>

  @if (activeTab() === 0) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="company-select">
      <mat-select [value]="selectedCompanyId()" (valueChange)="companyChanged.emit($event)">
        @for (c of companiesList(); track c.id) {
          <mat-option [value]="c.id">{{ c.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <div class="buttons">
    <app-button
      class="icon"
      [openFilter]="filterOptionsService.getOptions()">
      <mat-icon>filter_alt</mat-icon>
    </app-button>
  </div>
</mat-toolbar>

<mat-tab-group
  mat-stretch-tabs="false"
  animationDuration="0ms"
  [dynamicHeight]="true"
  [selectedIndex]="activeTab()"
  (selectedIndexChange)="tabChanged.emit($event)">
  <mat-tab label="Company"></mat-tab>
  <mat-tab label="Admin"></mat-tab>
</mat-tab-group>
